
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/van/volkswagen-caddy",
      function () {
        return require("private-next-pages/rims/van/volkswagen-caddy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/van/volkswagen-caddy"])
      });
    }
  